import capabilities from './capabilities'
import analysisConfigure from './analysisConfigure'
import analysisRun from './analysisRun'

export * from './helpers'
// 宙斯可见元素白名单：没登记的元素，宙斯看不到、指不到、点不到。
const registries = {
  'capabilities.home': capabilities,
  'analysis.configure': analysisConfigure,
  'analysis.result': analysisRun,
}
export const registryFor = pageKey => registries[pageKey] || []
